$(document).ready(function () {
  var $navButtons = $(".collection-navigation-button");
  var $collectionBlocks = $(".collection-navigation-block");

  $navButtons.on("click", function () {
    var activeCollectionHandle = $(this).data("collection");

    $navButtons.removeClass("active");
    $(this).addClass("active");

    $collectionBlocks.each(function () {
      $(this).removeClass("active");
      if ($(this).data("collection") === activeCollectionHandle) {
        $(this).addClass("active");
      }
    });
  });
});
